// src/pages/meeting/NoticePage.jsx
import React, { useEffect, useState, useMemo, use } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getNotices, deleteNotice } from "../../../api/meeting";

import SearchFilterBar from "../../../components/common/board/SearchFilterBar";
import BoardTable from "../../../components/common/board/BoardTable";
import BoardToolbar from "../../../components/common/board/BoardToolbar";
import PageHeader from "../../../components/common/ui/PageHeader";
import BoardPagination from "../../../components/common/board/BoardPagination";
// 날짜 포맷 함수 추가
import { formatDate } from "../../../utils/date"; // 경로는 실제 프로젝트 구조에 맞게 조정 필요

const NoticePage = () => {
  const navigate = useNavigate();
  const { id: projectId } = useParams();

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  // 검색 관련
  const [q, setQ] = useState("");
  const [searchField, setSearchField] = useState("title");

  // 날짜
  const [dateFilter, setDateFilter] = useState("all");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // 페이지네이션
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [total, setTotal] = useState(0);

  // 🔥 Safety 방식과 동일하게 "검색 눌렀을 때만 검색 실행"
  const [searchTrigger, setSearchTrigger] = useState(0);

  // 데이터 로드
  const fetchData = async () => {
    try {
      setLoading(true);

      const res = await getNotices({
        project: localStorage.getItem("projectId"),
        q,
        search_field: searchField,
        start_date: startDate,
        end_date: endDate,
        page,
        page_size: pageSize,
      });

      setItems(res.data.results ?? []);
      setTotal(res.data.total ?? 0);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // 검색Trigger, page, pageSize 변화에만 반응 (Safety 구조 동일)
  useEffect(() => {
    fetchData();
  }, [searchTrigger, page, pageSize]); //Changed

  const rows = useMemo(() => items ?? [], [items]);

  const handleRowClick = (id) => navigate(`${id}/view`);

  const handleDelete = async (id) => {
    if (!window.confirm("정말 삭제하시겠습니까?")) return;
    try {
      await deleteNotice(id);
      fetchData();
    } catch (err) {
      console.error(err);
    }
  };

  // 목록 컬럼
  const columns = [
    {
      key: "title",
      header: "제목",
      align: "left", // <td> 정렬
      headerAlign: "center", // <th> 정렬
    },
    { key: "created_by", header: "작성자" },
    {
      key: "created_at",
      header: "작성일",
      render: (row) => formatDate(row.created_at),
    },
  ];

  return (
    <div className="p-6 w-full">
      <PageHeader>공지사항</PageHeader>

      <BoardToolbar 
      right={
      <>
        <SearchFilterBar
          q={q}
          onChangeQ={(v) => setQ(v)}
          onSearch={() => {
            setPage(1);
            setSearchTrigger((x) => x + 1); //Changed
          }}
          searchField={searchField}
          onChangeSearchField={(v) => {
            setSearchField(v);
          }}
          dateFilter={dateFilter}
          onChangeDateFilter={setDateFilter}
          startDate={startDate}
          endDate={endDate}
          onDateChange={({ start, end }) => {
            setStartDate(start);
            setEndDate(end);
          }}
          pageSize={pageSize}
          onChangePageSize={(v) => {
            setPageSize(v);
          }}
        />
        <button
          className="btn-create"
          onClick={() => navigate(`../notice/new`)}
        >
          새 공지 작성
        </button>
      </>
      }
      />

      {loading ? (
        <p>불러오는 중...</p>
      ) : (
        <>
          <BoardTable
            columns={columns}
            rows={rows}
            keyField="id"
            onRowClick={(row) => navigate(`../notice/${row.dns}/view`)}
          />

          <BoardPagination
            page={page}
            pageSize={pageSize}
            total={total}
            onPageChange={(p) => setPage(p)}
          />
        </>
      )}
    </div>
  );
};

export default NoticePage;
